import { useEffect, useState } from 'react';
import { message } from 'antd';

export function useIsOnline() {
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  function setStatusToBody(status: 'online' | 'offline') {
    const node = document.querySelector('body');
    if (!node) {
      return;
    }
    if (status === 'online') {
      node.classList.remove('offline');
    } else {
      node.classList.add('offline');
    }
  }

  useEffect(() => {
    function setOnline() {
      setIsOnline(true);
      setStatusToBody('online');
      message.success({ content: 'You are Back Online', duration: 1, key: 'online-status' });
    }

    function setOffline() {
      setIsOnline(false);
      setStatusToBody('offline');
      message.error({
        content: 'Oops, You are Offline, Please check your internet connection',
        duration: 1.5,
        key: 'online-status',
      });
    }

    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);
    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return isOnline;
}
